module.exports = __webpack_public_path__ + "media/images/bread-302c8e57e5e2130aa490f42f8f693e35.jpg";